import { createFileRoute } from '@tanstack/react-router';

import { AuditView } from '../../administracja/AuditView';

export const Route = createFileRoute('/administracja/audit')({
  component: AuditView,
});
